module.exports = __webpack_public_path__ + "img/share_qrcode_bg1_2.66cedd1a.png";